<template>
  <div class="relative h-full w-full">
    <div class="mb-5 mt-4 flex justify-center">
      <img
        v-if="brokerLogo"
        class="md:w-21 mx-auto mt-4 h-11 md:mt-10"
        :src="brokerLogo"
        alt="broker logo"
      />
    </div>
    <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
    <layout>
      <div>
        <h3 class="text-left text-3xl text-dark-blue">
          <span v-if="isLogin == true">Log in</span>
          <span v-else>Create Your Account</span>
        </h3>
        <progress-indicator
          :current-step="currentStep"
          :length="3"
        />
        <div class="-mt-2 flex justify-between">
          <p class="text-xxs font-semibold text-dark-gray">Select Carrier</p>
          <p class="-ml-3 text-xxs font-semibold text-dark-gray">
            Verify Identity
          </p>
          <p class="text-xxs font-semibold text-dark-gray">Join Carrier</p>
        </div>
        <h2 class="my-6 text-left text-xl text-dark-blue">
          {{ title }}
        </h2>
        <slot />
      </div>
    </layout>
    <div class="flex w-full items-center justify-center pb-6 pt-2">
      <button
        v-if="currentUser?.id > 0"
        class="flex items-center whitespace-nowrap text-1md text-gray-over-dark"
        variant="link"
        @click="logOut()"
      >
        Log Out
      </button>
    </div>
  </div>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ProgressIndicator from '@/components/ProgressIndicator.vue';

export default {
  name: 'CreateAccountLayout',
  components: {
    Layout,
    ProgressIndicator,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
    isLogin() {
      return this.$store.state.isLogin || false;
    },
    currentUser() {
      return this.$store.state.users?.currentUser || null;
    },
  },
  async created() {
    const clientId = localStorage.getItem('client_id');
    await this.$store.dispatch('brokers/getLogoByClientId', clientId);
  },
  methods: {
    async logOut() {
      const logoutRes = await this.$store.dispatch('users/userSignOut');
      if (logoutRes) {
        this.$router.push({ name: 'SignUp' });
      }
    },
  },
};
</script>
